// @ts-nocheck
import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import plusIcon from '../assets/icons/calculator/plus.svg';
import minusIcon from '../assets/icons/calculator/minus.svg';

export default function Counter({
  id,
  onChange,
  count,
  minCount,
  step,
  restart,
  packages = undefined,
  multiplicity = null,
  inputClassName,
}) {
  multiplicity = multiplicity === null || multiplicity === 0 ? 1 : multiplicity;

  const buttonMinus = useRef('buttonMinus');
  const buttonPlus = useRef('buttonPlus');
  const counterInput = useRef('counterInput');
  const [fakeCount, setFakeCount] = useState(count);
  const [disabled, setDisabled] = useState(true);
  const [fetchCounts, setFetchCounts] = useState(1);
  const handlerToRes = () => {
    if (restart) restart(id);
  };

  useEffect(() => {
    let minusButton = buttonMinus.current;
    if (count <= minCount) {
      onChange(minCount);
      setFakeCount(minCount);
    }
    if (count == 0) {
      onChange(minCount);
      setFakeCount(minCount);
    }
    if (count === minCount) {
      minusButton.classList.add('boxCount-button-disable');
      setDisabled(true);
    } else {
      minusButton.classList.remove('boxCount-button-disable');
      setDisabled(false);
    }
  }, [count, minCount, onChange]);

  const mountedCounter2 = useRef(true);
  useEffect(() => {
    if (mountedCounter2.current) {
      // do componentDidMount logic
      mountedCounter2.current = false;
    } else {
      // do componentDidUpdate logic
      handlerToRes();
    }
  }, [fetchCounts]);

  const minusHandler = () => {
    onChange(+count - step);
    setFakeCount(+fakeCount - step);
    setFetchCounts(fetchCounts + 1);
  };

  const plusHandler = () => {
    onChange(+count + step);
    setFakeCount(+fakeCount + step);
    setFetchCounts(fetchCounts + 1);
  };

  const fakeInputHandler = (e) => {
    setFakeCount(e.target.value);
    setFetchCounts(fetchCounts + 1);
  };

  const keypressHandler = (event) => {
    if (event.key === 'Enter') {
      counterInput.current.blur();
    }
  };

  const inputHandler = (e) => {
    const value = Number(e.target.value || minCount);
    if (packages) {
      setFakeCount(Math.round(value));
      onChange(Math.round(value));
      setFetchCounts(fetchCounts + 1);
      return;
    }

    let newCount = Math.round(value / multiplicity) * multiplicity;

    setFakeCount(Number(newCount));
    onChange(Number(newCount));
    setFetchCounts(fetchCounts + 1);
  };

  const inputClassNames = classNames({
    'boxCount-counter': true,
    [inputClassName]: Boolean(inputClassName),
  });

  return (
    <>
      <div id={id} className="calc-settings__list-item-setting calc-counter">
        <button
          className="boxCount-button boxCount-button-minus"
          ref={buttonMinus}
          onClick={() => minusHandler()}
          disabled={disabled}
        >
          <img loading="lazy" src={minusIcon} alt="-" />
        </button>
        <input
          value={fakeCount}
          className={inputClassNames}
          ref={counterInput}
          onBlur={inputHandler}
          onChange={fakeInputHandler}
          min={minCount}
          type="number"
          onKeyPress={(event) => keypressHandler(event)}
        />
        <button
          className="boxCount-button"
          ref={buttonPlus}
          onClick={() => plusHandler()}
        >
          <img loading="lazy" src={plusIcon} alt="+" />
        </button>
      </div>
    </>
  );
}
